export enum Environment {
  LOCAL = "local",
  DEV = "dev",
  STAGING = "staging",
  PRODUCTION = "production",
}

// Backend deploys selectable via a bare URL query flag on previews, e.g.
// `?dev2` → route backend calls to the dev2 aigent-service. Mirrors the
// established policy-hydration `?dev1/?dev2/?ppe` convention. Must match
// SUPPORTED_BACKEND_ENVS in functions/src/utils/backend-aigent-client.ts.
const BACKEND_ENV_KEYS = ["prod", "ppe", "dev", "dev1", "dev2"] as const;

/** Returns the backend-env flag present in the current URL (`?dev2`), if any. */
export const getBackendEnvFromUrl = (): string | undefined => {
  if (typeof window === "undefined") return undefined;
  const params = new URLSearchParams(window.location.search);
  return BACKEND_ENV_KEYS.find((key) => params.has(key));
};

// There is probably a better way to do it using env variables etc. But this is fast and clean, good enough for now.
export const getEnvironment = () => {
  const hostname = window.location.hostname;
  if (hostname === "localhost" || hostname === "127.0.0.1") {
    return Environment.LOCAL;
  } else if (hostname.includes("aigency-portal-staging")) {
    return Environment.STAGING;
  } else if (hostname.includes("--pr")) {
    return Environment.DEV;
  } else {
    return Environment.PRODUCTION;
  }
};
